import React, { ChangeEventHandler } from "react";
import { FormControl, Grid, OutlinedInput } from "@mui/material";
import CuvoInputLabel from "../common/CuvoInputLabel";
import { lowerCase } from "lodash";
import { Qualifier } from "../../model/qualifier";

export interface ComparatorValueInputProps {
  formValues: Qualifier;
  handleTextChange: ChangeEventHandler;
}

const ComparatorValueInput = ({
  formValues,
  handleTextChange,
}: ComparatorValueInputProps) => {
  const type = formValues["type"] || "";
  const comparator = formValues["comparator"];

  if (!type || !comparator) return null;

  if (["text", "number"].includes(type) && comparator !== "between") {
    const label = comparator === "oneOf" ? "Value (Comma separated)" : "Value";

    const value = (() => {
      if (comparator === "equals") return formValues["equals"];
      if (comparator === "notEquals") return formValues["notEquals"];
      if (comparator === "min") return formValues["min"];
      if (comparator === "max") return formValues["max"];
      if (comparator === "oneOf") return formValues["oneOf"];

      return "";
    })();

    return (
      <FormControl className="custom-select" fullWidth>
        <CuvoInputLabel label={label} showRequiredIndicator />
        <OutlinedInput
          type={lowerCase(type)}
          name={comparator}
          value={value}
          onChange={handleTextChange}
        />
      </FormControl>
    );
  }

  if (type === "number" && comparator === "between") {
    return (
      <Grid container gap={2.5}>
        <Grid item flexGrow={1}>
          <FormControl className="custom-select" fullWidth>
            <CuvoInputLabel label="Min value" showRequiredIndicator />
            <OutlinedInput
              type="number"
              name="min"
              value={formValues["min"]}
              onChange={handleTextChange}
            />
          </FormControl>
        </Grid>
        <Grid item flexGrow={1}>
          <FormControl className="custom-select" fullWidth>
            <CuvoInputLabel label="Max value" showRequiredIndicator />
            <OutlinedInput
              type="number"
              name="max"
              value={formValues["max"]}
              onChange={handleTextChange}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (type === "date" && comparator === "between") {
    return (
      <Grid container gap={2.5}>
        <Grid item flexGrow={1}>
          <FormControl className="custom-select" fullWidth>
            <CuvoInputLabel label="Min value" showRequiredIndicator />
            <OutlinedInput
              type="date"
              name="min"
              value={formValues["min"]}
              onChange={handleTextChange}
            />
          </FormControl>
        </Grid>
        <Grid item flexGrow={1}>
          <FormControl className="custom-select" fullWidth>
            <CuvoInputLabel label="Max value" showRequiredIndicator />
            <OutlinedInput
              type="date"
              name="max"
              value={formValues["max"]}
              onChange={handleTextChange}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (type === "date" && ["min", "max"].includes(comparator)) {
    return (
      <FormControl className="custom-select" fullWidth>
        <CuvoInputLabel label="Value" showRequiredIndicator />
        <OutlinedInput type="date" name="value" onChange={handleTextChange} />
      </FormControl>
    );
  }

  return null;
};

export default ComparatorValueInput;
